import conn from './connections';

export const authenticate = loginData => conn.postJSON(`${conn.base_url}/authenticate`, loginData);
export const getCurrentUserData = () => conn.getJSON(`${conn.base_url}/users/current`);
export const setAuthToken =  token => conn.setAuthToken(token);
